/* Venture Optics product page: swipe gallery, and swapping the gallery and colorway
   description when Dawn's product-info reports a variant change. */

if (!customElements.get('vo-gallery')) {
  customElements.define(
    'vo-gallery',
    class VoGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.vo-gallery__track');
        this.slides = Array.from(this.querySelectorAll('.vo-gallery__slide'));
        this.bars = Array.from(this.querySelectorAll('.vo-gallery__bar'));
        this.count = this.querySelector('.vo-gallery__count');
        this.index = 0;
        if (this.slides.length < 2) return;

        this.bars.forEach((bar) => bar.addEventListener('click', () => this.go(Number(bar.dataset.index))));
        this.querySelectorAll('.vo-gallery__arrow').forEach((arrow) =>
          arrow.addEventListener('click', () => this.go(this.index + Number(arrow.dataset.step), true))
        );

        const viewport = this.querySelector('.vo-gallery__viewport');
        viewport.addEventListener('pointerdown', (event) => {
          this.startX = event.clientX;
        });
        viewport.addEventListener('pointerup', (event) => {
          if (this.startX === undefined) return;
          const dx = event.clientX - this.startX;
          this.startX = undefined;
          if (dx < -40) this.go(this.index + 1);
          else if (dx > 40) this.go(this.index - 1);
        });
        viewport.addEventListener('pointercancel', () => {
          this.startX = undefined;
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') this.go(this.index + 1, true);
          if (event.key === 'ArrowLeft') this.go(this.index - 1, true);
        });
      }

      go(index, wrap = false) {
        const total = this.slides.length;
        if (wrap) index = (index + total) % total;
        index = Math.max(0, Math.min(index, total - 1));
        this.index = index;
        this.track.style.transform = `translateX(-${index * 100}%)`;
        this.slides.forEach((slide, i) => {
          if (i === index) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        this.bars.forEach((bar, i) => {
          if (i === index) bar.setAttribute('aria-current', 'true');
          else bar.removeAttribute('aria-current');
        });
        if (this.count) this.count.textContent = `${index + 1} / ${total}`;
      }
    }
  );
}

if (typeof subscribe === 'function' && !window.voVariantSwap) {
  window.voVariantSwap = subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, html } }) => {
    ['VoGallery', 'VoDescription'].forEach((prefix) => {
      const current = document.getElementById(`${prefix}-${sectionId}`);
      const updated = html.getElementById(`${prefix}-${sectionId}`);
      if (current && updated) current.replaceWith(document.importNode(updated, true));
    });
  });
}
